import React, { useMemo, useState } from 'react';
import { Image, Space, Button } from 'antd';

/**
 * ImagePreviewList
 * - PreviewGroup
 * - Giới hạn số ảnh hiển thị (mặc định 8)
 * - Toggle xem tất cả / thu gọn
 *
 * images: [{ id?, src }]
 */
export default function ImagePreviewList({
    images,
    max = 8,
    thumbSize = 50,
    showToggle = true,
    initialShowAll = false,
    getSrc, // optional: (item) => string
    getKey, // optional: (item, index) => string|number
    className,
    buttonClassName,
}) {
    const [showAll, setShowAll] = useState(initialShowAll);

    const list = useMemo(() => (Array.isArray(images) ? images : []), [images]);

    const srcOf = (item) => {
        if (typeof getSrc === 'function') return getSrc(item);
        return item?.src || '';
    };

    const keyOf = (item, index) => {
        if (typeof getKey === 'function') return getKey(item, index);
        return item?.id || item?.src || index;
    };

    if (!list.length) return null;

    const showing = showAll ? list : list.slice(0, max);

    return (
        <div className={className}>
            <Image.PreviewGroup>
                <Space wrap>
                    {showing.map((item, index) => {
                        const src = srcOf(item);
                        if (!src) return null;

                        return (
                            <Image
                                key={keyOf(item, index)}
                                height={thumbSize}
                                width={thumbSize}
                                src={src}
                                style={{
                                    border: '1px solid #dedede',
                                    objectFit: 'cover',
                                    objectPosition: 'center',
                                }}
                            />
                        );
                    })}
                </Space>
            </Image.PreviewGroup>

            {showToggle && list.length > max && (
                <div className={`mt-2 ${buttonClassName || ''}`}>
                    <Button size="small" onClick={() => setShowAll((v) => !v)}>
                        {showAll ? 'Thu gọn' : `Xem tất cả (${list.length})`}
                    </Button>
                </div>
            )}
        </div>
    );
}